import { Tag } from "@chakra-ui/react";
import { AddIcon } from "../../../../shared/views/icons";

export const AddFilterButton = ({
  onClick,
  label,
}: {
  onClick: () => void;
  label: string;
}) => {
  return (
    <Tag.Root
      py={1}
      fontSize="xs"
      colorPalette="primary"
      onClick={onClick}
      as="button"
      cursor={"pointer"}
    >
      <Tag.StartElement>
        <AddIcon />
      </Tag.StartElement>
      <Tag.Label>{label}</Tag.Label>
    </Tag.Root>
  );
};
